import React from 'react';
import { Outlet } from 'react-router-dom';
import { useEnrollmentAccess } from '../../hooks/access/useEnrollmentAccess';
import { useCourseId } from '../../hooks/course/useCourseId';
import AccessDenied from '../access/AccessDenied';

const CommunityRoute: React.FC = () => {
  const courseId = useCourseId() ?? '';
  const { canAccessCommunity } = useEnrollmentAccess(courseId);

  if (!canAccessCommunity) {
    return (
      <AccessDenied
        message="Comunidade não disponível para esta matrícula"
        statusCode={403}
      />
    );
  }

  return <Outlet />;
};

export default CommunityRoute;
